var Logs = {}
Logs.print = function (...logs) {
    if (typeof webpackHotUpdate === "function") {
        console.log(...logs)
    }
}
export {
    Logs
}